import { useWorldExperience } from "./WorldExperienceProvider";
import { useLocation } from "react-router-dom";
import { isServiceRoute } from "./districts";

export function WorldControls() {
  const { pathname } = useLocation();
  const { mode, preference, capability, setPreference } = useWorldExperience();
  const service = isServiceRoute(pathname);
  const effectiveMode =
    mode === "off"
      ? "off"
      : mode === "balanced"
        ? "balanced"
        : mode === "lite" && service
          ? "lite"
          : "static";
  return (
    <div className="world-controls" aria-label="World view">
      <span>World</span>
      <button
        type="button"
        aria-pressed={effectiveMode === "static"}
        onClick={() => setPreference("static")}
      >
        Static
      </button>
      {capability.balancedAllowed && (
        <button
          type="button"
          aria-pressed={
            effectiveMode === "balanced" && preference === "balanced"
          }
          onClick={() => setPreference("balanced")}
        >
          Balanced
        </button>
      )}
      {service && capability.allowed && (
        <button
          type="button"
          aria-pressed={effectiveMode === "lite" && preference === "lite"}
          onClick={() => setPreference("lite")}
        >
          Lite
        </button>
      )}
      <button
        type="button"
        aria-pressed={effectiveMode === "off"}
        onClick={() => setPreference("off")}
      >
        Off
      </button>
    </div>
  );
}
